import React, { useEffect, useRef, useState } from 'react';
import dateFNS from 'date-fns';
import { convertStringToDate, Input, LoaderIcon, SelectAutocomplete, useClickOutside } from '@devesharp/react/web';
import { faBarcode, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from '@unform/web';
import { Link } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import Style from './SellerSelect.style';
import { useViewList } from '~/hooks/useViewList';
import { SellersSearchResolve } from '~/api';
import { CNPJAndCPFMask } from '~/services';
import { useDebounce } from '~/hooks/useDebounce';
import { LoadingPage } from '~/components';
import {
   companyPageSelectState,
   companySelectState,
   companyShowInfoState,
   normalizeCompany,
   uniqueCompanyUserState,
} from '~/recoil/company-select.state';
import { useUser } from '~/hooks';

export function SellerSelectInput(): any {
   const user = useUser();
   const [value, setValue] = useState('');
   const dropRef = useRef(null);
   const [sellerPageSelect, setSellerPageSelect] = useRecoilState(companyPageSelectState);
   const [sellerSelect, setSellerSelect] = useRecoilState(companySelectState);
   const [, setShowInfoSeller] = useRecoilState(companyShowInfoState);
   const [selectedName, setSelectedName] = useState(sellerSelect?.name);
   const [uniqueSeller, setUniqueSeller] = useRecoilState(uniqueCompanyUserState);

   const [visibleDropDown, setVisibleDropDown] = useState(false);

   const { resources, setFilters, searching, starting } = useViewList({
      resolves: {
         items: SellersSearchResolve,
      },
   });

   useEffect(() => {
      if (!sellerPageSelect && !sellerSelect) {
         const seller = user.sellers[0] ?? resources[0];
         
         if (seller) {
            const company = normalizeCompany(seller);
            setSellerSelect(company);
            setSellerPageSelect(company);
            setSelectedName(company.name);
         }
      }
   }, [sellerPageSelect, resources]);

   useEffect(() => {
      if (sellerSelect) {
         setSelectedName(sellerSelect.name);
      }
   }, [sellerSelect]);

   useClickOutside(() => {
      setVisibleDropDown(false);
   }, dropRef);

   function onSelectSeller(seller: any): void {
      if (!seller) {
         setSellerSelect(null);
         setSelectedName('Todos os estabelecimentos');
      } else {
         const company = normalizeCompany(seller);
         setSelectedName(company.name);
         setSellerSelect(company);
         setSellerPageSelect(company);
      }
      setVisibleDropDown(false);
      setValue('');
   }

   const valueSearch = useDebounce(value, 250);

   useEffect(() => {
      setFilters(() => ({
         name: valueSearch,
      }));
   }, [valueSearch]);

   if (uniqueSeller || sellerPageSelect) {
      return null;
   }

   return (
      <Style ref={dropRef}>
         <div>
            {/* <Form onSubmit={() => {}}> */}
            {/*   <SelectAutocomplete title="" name="seller" placeholder="Selecione o estabelecimento" /> */}

            <div className="input-title">Selecionar Estabelecimento</div>

            <div className="d-flex align-items-end" onClick={() => setVisibleDropDown((i) => !i)}>
               <div>
                  <div className="selected2">{selectedName}</div>
               </div>
               <div className="arrow">
                  <svg
                     height="20"
                     width="20"
                     viewBox="0 0 20 20"
                     aria-hidden="true"
                     focusable="false"
                     fill="#222"
                     className="css-6q0nyr-Svg"
                  >
                     <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
                  </svg>
               </div>
            </div>

            {visibleDropDown && (
               <div className="dropdown">
                  <div className="search">
                     <Form onSubmit={() => {}}>
                        <Input
                           name="sdsd"
                           placeholder="Buscar CPF, CNPJ ou Nome"
                           onKeyUp={(e: any) => {
                              setValue(e.target.value);
                              e.stopPropagation();
                           }}
                           suffix={
                              <>
                                 <FontAwesomeIcon icon={faSearch} color="black" />
                              </>
                           }
                        />
                     </Form>
                  </div>

                  <div className="listing">
                     {(searching || starting) && (
                        <div className="loading-page">
                           <LoaderIcon />
                        </div>
                     )}
                     {!searching &&
                        resources?.map((resource: any) => (
                           <div className="item" onClick={() => onSelectSeller(resource)}>
                              <div className="name">{resource.name}</div>
                              <div className="document">
                                 {resource.document ? (
                                    <>
                                       {resource.document.length > 11 ? 'CNPJ' : 'CPF'}{' '}
                                       {CNPJAndCPFMask(resource.document)}
                                    </>
                                 ) : (
                                    'Documento não informado'
                                 )}
                              </div>
                           </div>
                        ))}
                     {!searching && resources.length === 0 && !searching && !starting && (
                        <div className="empty">Nenhum estabelecimento encontrado</div>
                     )}
                  </div>
               </div>
            )}
         </div>
         {/* </Form> */}
      </Style>
   );
}
